const PROFILE_MARKERS = [
  { pattern: /Structured dress profile JSON:\s*/i, type: 'dress' },
  { pattern: /Structured groom suit profile JSON:\s*/i, type: 'groom' },
];

const formatValue = (value) => {
  if (value == null || value === '') return null;
  if (Array.isArray(value)) {
    const filtered = value.filter((entry) => entry != null && String(entry).trim() !== '');
    if (!filtered.length) return null;
    return filtered.join(', ');
  }
  return String(value).trim();
};

const pushRow = (rows, label, value) => {
  const formatted = formatValue(value);
  if (formatted) rows.push({ label, value: formatted });
};

export function parseWeddingListingDescription(description) {
  let text = String(description || '').trim();
  let profile = null;
  let profileType = null;

  for (const { pattern, type } of PROFILE_MARKERS) {
    const match = text.match(pattern);
    if (!match || match.index == null) continue;

    const jsonPart = text.slice(match.index + match[0].length).trim();
    text = text.slice(0, match.index).trim();

    try {
      profile = JSON.parse(jsonPart);
      profileType = type;
    } catch {
      profile = null;
      profileType = null;
    }
    break;
  }

  text = text.replace(/^Type:\s*[^\n]+\n+/i, '').trim();
  // Legacy rows sanitized with newlines collapsed into spaces:
  // "Type: Bridesmaid Dresses عربي…" — strip English Type header only.
  text = text
    .replace(/^Type:\s+[A-Za-z][A-Za-z0-9 &/'>\-()]*(?=\s+[\u0600-\u06FF])/i, '')
    .trim();

  return {
    cleanDescription: text,
    profile,
    profileType,
  };
}

export function getWeddingProfileDisplayRows(profile, profileType = 'dress') {
  if (!profile || typeof profile !== 'object') return [];

  const rows = [];
  const isGroom = profileType === 'groom';
  const style = profile.style || {};
  const fabric = profile.fabric || {};
  const measurements = profile.measurements || {};
  const comfort = profile.comfort || {};
  const pricing = profile.pricing || {};
  const logistics = profile.logistics || {};

  pushRow(rows, isGroom ? 'Suit type' : 'Dress type', profile.occasion);
  pushRow(rows, isGroom ? 'Suit style' : 'Silhouette', style.silhouette);
  if (!isGroom) {
    pushRow(rows, 'Neckline', style.neckline);
    pushRow(rows, 'Sleeves', style.sleeves);
    pushRow(rows, 'Back', style.back);
    if (style.train && style.train !== 'None') pushRow(rows, 'Train', style.train);
  } else {
    pushRow(rows, 'Lapel', style.back);
  }
  pushRow(rows, 'Style', style.vibe);

  pushRow(rows, 'Main fabric', fabric.main);
  pushRow(rows, isGroom ? 'Pattern' : 'Lining', fabric.lining);
  pushRow(rows, 'Embellishments', fabric.embellishments);
  pushRow(rows, 'Color', fabric.color);

  pushRow(rows, isGroom ? 'Chest (cm)' : 'Bust (cm)', measurements.bust);
  pushRow(rows, 'Waist (cm)', measurements.waist);
  if (isGroom) {
    pushRow(rows, 'Shoulder (cm)', measurements.shoulder);
    pushRow(rows, 'Sleeve (cm)', measurements.sleeve);
    pushRow(rows, 'Trouser waist (in)', measurements.trouser_waist_in);
    pushRow(rows, 'Trouser length (in)', measurements.trouser_length_in);
  } else {
    pushRow(rows, 'Hips (cm)', measurements.hips);
  }
  pushRow(rows, 'Height (cm)', measurements.height);
  pushRow(rows, 'Weight range', measurements.weight_range);
  pushRow(rows, 'Size', measurements.size);
  pushRow(rows, 'Adjustability', measurements.adjustability);

  pushRow(rows, 'Weight feel', comfort.weight);
  pushRow(rows, 'Easy to move in', comfort.mobility);
  pushRow(rows, 'Dance-friendly', comfort.danceable);
  pushRow(rows, 'Flaws / damages', comfort.flaws);

  pushRow(rows, 'Deposit', pricing.deposit);
  if (!isGroom) pushRow(rows, 'Cleaning policy', pricing.cleaning_policy);
  pushRow(rows, 'Try-on', logistics.try_on);
  pushRow(rows, 'Delivery', logistics.delivery);
  pushRow(rows, isGroom ? 'Included items' : 'Included accessories', profile.extras);

  return rows;
}
